import React, { useState } from "react";
import Layout from "../../Components/Layout";
import { Icon } from "@iconify/react";
import { Toaster } from "react-hot-toast";
import ProfileInfo from "./ProfileInfo";
import Documents from "./Documents";
import '../../Assets/CSS/EmployeeOnboard.css';
import AppointmentLetter from "./AppointmentLetter";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { BigTextbold, BigTexts, LighterBold, Lightly, smallText, TwntyText } from "../../Assets/CSS/Text";
import SalaryStructure from "./SalaryStructure";

const EmployeeProfile = () => {
    const [documentsApproved, setDocumentsApproved] = useState(false);
    const [salaryCompleted, setSalaryCompleted] = useState(false);
    const navigate = useNavigate();
    const { id } = useParams();
    const { state } = useLocation(); // state object
    const empData = state?.empData;  // safely read state

    console.log("ID from URL:", id);
    console.log("Employee Data passed:", empData);

    const [activeTab, setActiveTab] = useState("info");
    const steps = ["info", "docs", "salstr", "letter"]; // Step order = 1,2,3
    const currentStep = steps.indexOf(activeTab) + 1;
    // info → 1, docs → 2, letter → 3
    const capitalize = (str = "") =>
        str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();

    return (
        <Layout>
            <Toaster position="top-right" reverseOrder={false} />
            <div className="backgound-main-content ">
                <div className="px-2">
                    {/* Back Button */}
                    <div className='d-flex gap-2 align-item-center mt-2 '
                        style={{ cursor: 'pointer' }}>
                        <Icon icon='akar-icons:arrow-left'
                            style={{ color: '#909090' }}
                            className='align-item-center '
                            onClick={() => {
                                navigate(-1);
                            }} />
                        <h6 style={LighterBold}>Back</h6>

                    </div>

                    {/* Top Heading */}
                    <div
                        className="card mt-3 p-3 position-relative"
                        style={{
                            backgroundColor: "#EFF2FF",
                            boxShadow: "none",
                            border: "none",
                        }}
                    >
                        <div className="d-flex align-items-center gap-3">

                            {/* LEFT — PROFILE INITIALS */}
                            <div
                                className="rounded-circle d-flex justify-content-center align-items-center"
                                style={{
                                    ...TwntyText,
                                    width: "55px",
                                    height: "55px",
                                    backgroundColor: "#EFEFEF",
                                    border: "1px solid #F0F0F0",
                                    textTransform: "uppercase",
                                }}
                            >
                                {(() => {
                                    const first = empData?.firstName || "";
                                    const last = empData?.lastName || "";

                                    const fullName = `${first} ${last}`.trim();
                                    const parts = fullName.split(" ");

                                    if (parts.length === 1) {
                                        return parts[0].substring(0, 2);
                                    }
                                    return parts[0][0] + parts[parts.length - 1][0];
                                })()}
                            </div>

                            {/* RIGHT — NAME + JOB */}
                            <div className="d-flex flex-column">
                                <h5 className="m-0" style={{ fontWeight: 600 }}>
                                    {capitalize(empData?.firstName)} {capitalize(empData?.lastName)}
                                </h5>
                                <p className="m-0" style={{ color: "#6b6b6b" }}>
                                    {capitalize(empData?.designation)}
                                </p>
                            </div>
                        </div>

                        {/* CUSTOM STEP PROGRESS BOTTOM-RIGHT */}

                        <div
                            className="position-absolute d-flex flex-column"
                            style={{ bottom: "10px", right: "15px" }}
                        >
                            <div className="d-flex justify-content-between align-item-center">
                                <h6 style={{ ...Lightly, marginBottom: "0" }}>Progress</h6>

                                {/* Show count dynamically */}
                                <small style={smallText}>{currentStep}/{steps.length}</small>
                            </div>

                            <div className="d-flex align-items-center gap-2">

                                {/* Dynamic Steps */}
                                <div className="d-flex gap-1">
                                    {steps.map((step, index) => {
                                        const stepNumber = index + 1;

                                        return (
                                            <div
                                                key={step}
                                                style={{
                                                    width: "50px",
                                                    height: "4px",
                                                    borderRadius: "4px",
                                                    backgroundColor:
                                                        stepNumber <= currentStep ? "#00AFEF" : "#D8D8D8",
                                                }}
                                            ></div>
                                        );
                                    })}
                                </div>

                            </div>
                        </div>

                    </div>



                    {/* TAB BUTTONS */}

                    <div className="d-flex gap-2 mt-4">

                        {/* PERSONAL INFO TAB */}


                        <button
                            className={activeTab === "info" ? "EmployeeStep" : "EmployeeStepBefore"}
                            onClick={() => setActiveTab("info")}
                        >
                            <div className="tab-content-wrapper">
                                <div className="tab-left">
                                    <Icon icon="proicons:person" />
                                    <span>Personal Info</span>
                                </div>
                            </div>

                            <div className="tab-right">
                                {(activeTab === "docs" || activeTab === "letter" || activeTab === "salstr") ? (
                                    <Icon icon="weui:done2-filled" className="tab-right-icon" />
                                ) : (
                                    <span className="tab-placeholder-icon" />   // 👈 placeholder
                                )}
                            </div>
                        </button>


                        {/* DOCUMENTS TAB */}
                        <button
                            className={activeTab === "docs" ? "EmployeeStep" : "EmployeeStepBefore"}
                            onClick={() => setActiveTab("docs")}
                        >

                            <div className="tab-content-wrapper">
                                <div className="tab-left">
                                    <Icon icon="mi:document" />
                                    <span>Documents</span>
                                </div>


                            </div>


                            <div className="tab-right">
                                {(activeTab === "salstr" || activeTab === "letter") ? (
                                    <Icon icon="weui:done2-filled" className="tab-right-icon" />
                                ) : (
                                    <span className="tab-placeholder-icon" />   // 👈 placeholder
                                )}
                            </div>

                        </button>
                        {/* Salary Structure TAB */}
                        <button
                            className={activeTab === "salstr" ? "EmployeeStep" : "EmployeeStepBefore"}
                            disabled={!documentsApproved}
                            onClick={() => {
                                if (!documentsApproved) return;
                                setActiveTab("salstr");
                            }}
                        >
                            <div className="tab-content-wrapper">
                                <div className="tab-left">
                                    <Icon icon="tabler:coin-rupee" />
                                    <span>Salary Structure</span>
                                </div>
                            </div>
                            <div className="tab-right">
                                {activeTab === "letter" ? (
                                    <Icon icon="weui:done2-filled" className="tab-right-icon" />
                                ) : (
                                    <span className="tab-placeholder-icon" />

                                )}
                            </div>
                        </button>
                        {/* APPOINTMENT LETTER TAB */}
                        <button
                            className={activeTab === "letter" ? "EmployeeStep" : "EmployeeStepBefore"}
                            disabled={
                                !salaryCompleted &&
                                !empData?.ctcOfEmployee
                            }
                            onClick={() => {
                                if (
                                    !salaryCompleted &&
                                    !empData?.ctcOfEmployee
                                ) {
                                    return;
                                }

                                setActiveTab("letter");
                            }}
                        >
                            <div className="tab-content-wrapper">
                                <div className="tab-left">
                                    <Icon icon="majesticons:document" />
                                    <span>Appointment Letter</span>
                                </div>
                            </div>
                        </button>

                    </div>


                    {/* Render Selected Component */}
                    <div className="mt-4">
                        {activeTab === "info" && <ProfileInfo empData={empData} />}
                        {activeTab === "docs" && <Documents empData={empData} setActiveTab={setActiveTab} setDocumentsApproved={setDocumentsApproved} />}
                        {activeTab === "salstr" && <SalaryStructure empData={empData} setActiveTab={setActiveTab} setSalaryCompleted={setSalaryCompleted} />}
                        {activeTab === "letter" && <AppointmentLetter empData={empData} />}


                    </div>
                </div>

            </div>
        </Layout>
    );
};

export default EmployeeProfile;
